import React from "react";
import { Tabs, Tab, Grid } from "@mui/material";

const TabFilter = ({ options, selectedTab, onTabChange }) => {
  return (
    <Grid item xs={12} sm={8} md={6}>
      <Tabs
        value={selectedTab}
        onChange={onTabChange}
        sx={{
          padding: 0,
          justifyContent: "flex-start",
          minHeight: "auto",
        }}
        TabIndicatorProps={{
          sx: {
            backgroundColor: "#1E3A5F",
            height: "2px",
            width: "auto",
            left: "0",
            bottom: "0px",
          },
        }}
      >
        {options.map((option) => (
          <Tab
            key={option.value}
            label={option.label}
            value={option.value}
            sx={{
              textTransform: "none",
              fontFamily: "Inter, sans-serif",
              alignItems: "flex-start", // Align text to the start
              fontWeight: 500,
              fontSize: "13px",
              color: selectedTab === option.value ? "#1E3A5F" : "#ABABAB",
              minHeight: "auto",
              padding: "0px 0px 6px 0px",
              margin: "0px 10% 0px 0px",
              minWidth: "auto",
              width: "auro",
              display: option?.visibility,
            }}
          />
        ))}
      </Tabs>
    </Grid>
  );
};

export default TabFilter;
